var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:check-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 21.5C13.6819 21.5 14.8522 21.2672 15.9442 20.8149C17.0361 20.3626 18.0282 19.6997 18.864 18.864C19.6997 18.0282 20.3626 17.0361 20.8149 15.9442C21.2672 14.8522 21.5 13.6819 21.5 12.5C21.5 11.3181 21.2672 10.1478 20.8149 9.05585C20.3626 7.96392 19.6997 6.97177 18.864 6.13604C18.0282 5.30031 17.0361 4.63738 15.9442 4.18508C14.8522 3.73279 13.6819 3.5 12.5 3.5C10.1131 3.5 7.82387 4.44821 6.13604 6.13604C4.44821 7.82387 3.5 10.1131 3.5 12.5C3.5 14.8869 4.44821 17.1761 6.13604 18.864C7.82387 20.5518 10.1131 21.5 12.5 21.5ZM12.268 16.14L17.268 10.14L15.732 8.86L11.432 14.019L9.207 11.793L7.793 13.207L10.793 16.207L11.567 16.981L12.268 16.14Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3cd68d16dc46faca06ca381a9d64749f.svg";
export { ForwardRef as ReactComponent };